module.exports = __webpack_public_path__ + "img/dpvbrand.1103d6e3.png";